// Mock data para la página del Dr. Carlos Sanz Martín

export const doctorInfo = {
  name: "Dr. Carlos Sanz Martín",
  collegiateNumber: "Col. nº 47405674",
  specialty: "Medicina Familiar y Comunitaria",
  description: "Benefíciate de la mejor atención médica profesional e individualizada para ti y tu familia sin moverte de casa.",
  phone: "+34 623 783 157",
  email: "contacto@doctorsanz.es",
  whatsapp: "34623783157",
  whatsappMessage: "Hola Dr. Sanz, necesito solicitar una consulta médica. ¿Cuándo tendría disponibilidad?",
  location: "Valladolid y alrededores"
};

export const services = [
  {
    id: 1,
    title: "Consulta a Domicilio",
    description: "Diagnóstico y tratamiento de enfermedades comunes sin necesidad de desplazamiento",
    icon: "Stethoscope"
  },
  {
    id: 2,
    title: "Control de Crónicos",
    description: "Seguimiento de diabetes, hipertensión y otras enfermedades crónicas",
    icon: "Activity"
  },
  {
    id: 3,
    title: "Certificados Médicos",
    description: "Emisión de certificados, recetas y documentación médica",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Atención Pediátrica y Geriátrica",
    description: "Cuidado especializado para todas las edades: bebés, niños, adolescentes y personas mayores",
    icon: "Users"
  },
  {
    id: 5,
    title: "Asistencia Telefónica",
    description: "Orientación clínica y seguimiento de patologías de forma remota",
    icon: "Phone"
  },
  {
    id: 6,
    title: "Peritación Médica",
    description: "Emisión de informe pericial y defensa en tribunales",
    icon: "Scale"
  }
];

export const qualifications = [
  "Licenciado en Medicina por la Universidad de Valladolid",
  "Especialista en Medicina Familiar y Comunitaria",
  "Formación continua en urgencias y emergencias",
  "Experiencia en atención domiciliaria infantil y geriátrica",
  "Atención 100% personalizada e individualizada"
];

export const pricing = [
  {
    id: 1,
    type: "Consulta a Domicilio",
    price: "65€",
    description: "De lunes a viernes de 8:00 a 22:00h",
    features: [
      "Diagnóstico completo",
      "Recetas si es necesario",
      "Informe médico"
    ]
  },
  {
    id: 2,
    type: "Consulta en Horario Especial",
    price: "130€",
    description: "De 22:00 a 8:00h, fines de semana y/o festivos (sujeto a disponibilidad)",
    features: [
      "Diagnóstico completo",
      "Recetas si es necesario",
      "Informe médico"
    ],
    highlighted: true
  },
  {
    id: 3,
    type: "Control de Patologías Crónicas",
    price: "250€/mes",
    description: "1 visita semanal. De lunes a viernes de 8 a 22h",
    features: [
      "Ajuste de medicación",
      "Coordinación con especialistas",
      "Visita extra: 50 euros",
      "Visita extra nocturna: 70 euros",
      "Consulta telefónica adicional: 10 euros"
    ],
    whatsappMessage: "Hola Dr. Sanz, me gustaría contratar un servicio de revisiones periódicas. ¿Cuándo podríamos hablar? Gracias."
  },
  {
    id: 4,
    type: "Emisión de Recetas",
    price: "20€",
    description: "Fuera de consulta",
    features: [],
    whatsappMessage: "Hola Dr. Sanz, me gustaría solicitar una receta."
  },
  {
    id: 5,
    type: "Asistencia Telefónica",
    price: "20€",
    description: "En pacientes en seguimiento: 10€",
    features: [],
    whatsappMessage: "Hola Dr. Sanz me gustaría solicitar una consulta telefónica. ¿Cuándo podríamos hablar? Gracias."
  },
  {
    id: 6,
    type: "Vacunación",
    price: "20€",
    description: "Vacuna no incluida. Posibilidad de ser aportada por el doctor o por el paciente.",
    features: []
  },
  {
    id: 7,
    type: "Solicitud de Análisis e Interpretación Deportiva",
    price: "100€",
    description: "Primera cita telefónica y consulta posterior presencial para valoración de resultados. Análisis no incluidos.",
    features: []
  }
];

export const additionalInfo = [
  "Método de pago: efectivo, transferencia o Bizum",
  "Factura: Disponible para el reembolso de tu seguro",
  "Vacunas, medicamentos y análisis se abonarán a parte. Como alternativa, se proporcionarán las recetas para su adquisición en farmacia o el volante necesario para la atención en centro médico",
  "Asistencia telefónica: si no se atiende en el momento, se devolverá lo antes posible",
  "Las visitas incluyen: entrevista clínica (anamnesis), exploración, toma de constantes (tensión, saturación, glucemia capilar, si procede, y las recetas necesarias, así como reporte a la familia",
  "Visitas a pacientes ingresados en centros hospitalarios no incluída",
  "Para las consultas a pacientes ingresados en residencias de ancianos e instituciones, se debe contar con el consentimiento previo del servicio médico del centro",
  "Durante el periodo de vacaciones no se garantiza las revisiones periódicas, y se descontarán del mes"
];

export const coverageNote = "En área urbana de la ciudad de Valladolid y un radio de 20 kilómetros. Para citas fuera de este área, consultar.";

export const faqs = [
  {
    id: 1,
    question: "¿Cuál es el horario?",
    answer: "Ofrezco atención médica 24 horas al día, 7 días a la semana según disponibilidad. Para consultas programadas, el horario es de lunes a viernes de 8:00 a 22:00h."
  },
  {
    id: 2,
    question: "¿Qué zona de Valladolid cubres?",
    answer: "Atiendo todos los barrios de Valladolid capital sin coste adicional de desplazamiento. También puedo desplazarme a localidades cercanas con un pequeño suplemento. Consultar al pedir la cita."
  },
  {
    id: 3,
    question: "¿Cómo puedo reservar una cita?",
    answer: "Puedes contactarme a través de WhatsApp o teléfono y buscaremos el mejor horario para ti."
  },
  {
    id: 4,
    question: "¿Emites recetas y certificados?",
    answer: "Sí, como médico colegiado puedo emitir recetas médicas oficiales y todo tipo de certificados médicos (aptitud laboral, deportiva, etc.)."
  },
  {
    id: 5,
    question: "¿Qué debo preparar para la consulta?",
    answer: "Es útil tener a mano tus informes médicos, medicación actual y resultados de análisis o pruebas recientes. No es imprescindible, pero ayuda al diagnóstico."
  }
];

